import * as Y from 'yjs';
import { CommentD } from '../types';
import { findBlockRecursive } from './yjsBlockUtils';

export default function deleteComment(blocks: Y.Array<any>, blockId: string, commentId: string) {
    const block = findBlockRecursive(blocks, blockId);

    if (block) {
        block.set(
            'comments',
            block.get('comments')?.filter((comment: CommentD) => comment.id !== commentId),
        );
    }
}
